import GeneralServices from "./GeneralServices";

class CancellationServices {
  get = async () => {
    try {
      const response = await GeneralServices.getFile({
        loader: true,
        setLoading: () => {},
        endpoint: `supplements/downloadCancellation`,
      });

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "FormularioBaja.pdf";
      link.click();

      return response;
    } catch (err) {
      if (err.response) {
        throw err.response;
      } else {
        throw err;
      }
    }
  };
}

export default new CancellationServices();
